import { useEffect, useState } from "react";
import { Store, ChevronDown } from "lucide-react";
import api from "../lib/api";
import { apiError } from "../lib/auth";
import { useFlash } from "../lib/flash";

export default function LandingSettings() {
  const flash = useFlash();
  const [v, setV] = useState(null);
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/owner/landing").then((r) => setV({ ...r.data, override: r.data.override ?? "" }));
  useEffect(() => { load(); }, []);
  if (!v) return null;

  const shown = v.override !== "" ? Number(v.override) : v.real_count;
  const visible = v.show_count && shown >= Number(v.min_count || 0);
  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const r = await api.put("/owner/landing", {
        show_count: v.show_count, min_count: Number(v.min_count || 0),
        override: v.override === "" ? null : Number(v.override),
      });
      flash(r.data.flash);
      await load();
    } catch (ex) {
      flash(apiError(ex.response?.data?.detail) || "Kunne ikke gemme", "error");
    } finally {
      setBusy(false);
    }
  };

  return (
    <section className="panel" data-testid="landing-settings">
      <button className="ss-head" onClick={() => setOpen((o) => !o)} aria-expanded={open} data-testid="landing-settings-toggle">
        <Store size={18} /> <b>Forside: antal butikker</b>
        <span className={`pill ${visible ? "picked_up" : "cancelled"}`} data-testid="landing-settings-status">
          {visible ? `Vises (${shown})` : "Skjult"}
        </span>
        <ChevronDown size={18} style={{ marginLeft: "auto", transform: open ? "rotate(180deg)" : "none" }} />
      </button>
      {open && (
        <form className="ls-form" onSubmit={save}>
          <p className="muted" data-testid="landing-real-count">
            Rigtige aktive butikker lige nu: <b>{v.real_count}</b> (uden ejer-, demo-, test- og spærrede butikker; kræver forbundet Facebook-side eller mindst ét rigtigt opslag).
          </p>
          <label className="ls-check">
            <input type="checkbox" checked={v.show_count} onChange={(e) => setV({ ...v, show_count: e.target.checked })} data-testid="landing-show-count" />
            Vis antal butikker på forsiden
          </label>
          <div className="field">
            <label htmlFor="ls-min">Minimum før det vises</label>
            <input id="ls-min" type="number" min={0} value={v.min_count} onChange={(e) => setV({ ...v, min_count: e.target.value })} data-testid="landing-min-count" />
          </div>
          <div className="field">
            <label htmlFor="ls-ov">Vis i stedet tallet (valgfrit)</label>
            <input id="ls-ov" type="number" min={0} placeholder="Tom = brug det rigtige antal" value={v.override}
              onChange={(e) => setV({ ...v, override: e.target.value })} data-testid="landing-override" />
            <small className="ls-warn">Du står selv inde for, at et manuelt tal er sandt. Tal over 10 vises rundet ned, fx 23 → "20+".</small>
          </div>
          <button className="btn primary" disabled={busy} data-testid="landing-settings-save">{busy ? "Gemmer…" : "Gem"}</button>
        </form>
      )}
    </section>
  );
}
